import { env } from '@/env';
import { getQsocialsAccessToken } from '@/lib/logto';

import { TokenRifiutato } from './tempoReale';

/**
 * I token di Centrifugo li emette l'API di QSocials (contratto §1-bis): `GET /social/ws-token` per la
 * connessione (24 h), `?channel=<canale>` per la sottoscrizione (5 min, `403 channel_forbidden` se il
 * canale non e' nostro).
 *
 * ⚠️ Una `fetch` diretta e NON un endpoint RTK di proposito: un token che scade in 5 minuti non deve
 * finire in una cache. Ogni chiamata ne conia uno nuovo.
 *
 * Esiti: stringa = token · `TokenRifiutato` = definitivo (niente sessione QSocials, 403): la libreria
 * smette di riprovare · `Error` = passeggero (rete, 5xx, 401 di un token Logto appena scaduto): la
 * libreria riprova col suo backoff.
 */
export async function chiediWsToken(canale?: string): Promise<string> {
  const bearer = await getQsocialsAccessToken();
  if (!bearer) throw new TokenRifiutato('nessun token QSocials');
  const q = canale === undefined ? '' : `?channel=${encodeURIComponent(canale)}`;
  const r = await fetch(`${env.qsocialsApiUrl}/social/ws-token${q}`, {
    headers: { Authorization: `Bearer ${bearer}`, Accept: 'application/json' },
  });
  if (r.status === 403) throw new TokenRifiutato('ws-token 403');
  if (!r.ok) throw new Error(`ws-token ${r.status}`);
  const body = (await r.json()) as { token?: unknown };
  if (typeof body.token !== 'string' || body.token === '') throw new Error('ws-token senza token');
  return body.token;
}
